/**
 * @file   产品介绍欢迎页面
 * @create tianmu 2021/2/25
 * @update tianmu 2021/2/25
 * @update 2026/9/16 首页新增「文物易绘」轮播屏：指示条带切换进度与暂停（参考瑞鹿云-门户网站原型）
 * @update 2026/9/27 轮播改为「从右往左滑动替换」；停留时长按屏区分：智慧文旅 3s、文物易绘 10s
 */
import React, { useEffect, useRef, useState } from 'react'
import cls from 'classnames'
import { IntroHeader } from './header';
import { IntroFooter } from './footer';
import { ArchaeologySlide } from './archaeology';
import './index.scss'

/** 轮播屏数量：第 1 屏为原有智慧文旅首页（视频），第 2 屏为新增文物易绘 */
const SLIDE_COUNT = 2;
/** 各屏停留时长（毫秒）：下标为当前屏，值为停留该时长后切到下一屏（第 1 屏 3s，第 2 屏 10s） */
const SLIDE_DURATIONS = [3000, 10000];

/**
 * @description 产品介绍欢迎组件
 */
export const Introduction = () => {
    // 当前屏下标
    const [current, setCurrent] = useState(0);
    // 上一屏下标：滑动替换时作为「被覆盖」的底层屏，保证新屏始终自右侧滑入
    const [previous, setPrevious] = useState(null);
    // 各屏指示条进度元素
    const trackRefs = useRef([]);

    /**
     * 切换到指定屏：记录上一层用于遮挡，避免新屏自左侧滑入（首屏加载时不播放滑入动画）
     * @param {Number} next 目标屏下标
     */
    const goToSlide = (next) => {
        if (next === current) {
            return;
        }
        setPrevious(current);
        setCurrent(next);
    };

    // 禁用右键:
    function stop() {
        return false;
    }
    useEffect(() => {
        let doc = document.getElementById('homevideo')
        doc.oncontextmenu = stop;
    })

    /**
     * 自动轮播与指示条进度：按当前屏停留时长切到下一屏；页面隐藏期间不计时
     * 切屏后 elapsed 归零（effect 依赖 current 重新执行），进度条按该屏时长重新走满一轮
     */
    useEffect(() => {
        const duration = SLIDE_DURATIONS[current];
        let raf = 0;
        let elapsed = 0;
        let previousTime = performance.now();
        const tick = (time) => {
            const delta = Math.min(time - previousTime, 100);
            previousTime = time;
            if (!document.hidden) {
                elapsed += delta;
                if (elapsed >= duration) {
                    setPrevious(current);
                    setCurrent((current + 1) % SLIDE_COUNT);
                    return;
                }
            }
            trackRefs.current.forEach((track, idx) => {
                if (track) {
                    track.style.transform = `scaleX(${idx === current ? Math.min(elapsed / duration, 1) : 0})`;
                }
            });
            raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [current]);

    return (<div className='index-cont'>
        <IntroHeader />
        <div className='carousel-wrapper'>
            {/* 第 1 屏：智慧文旅（原有首页，样式不变） */}
            <div className={cls('carousel-slide', { active: current === 0, previous: previous === 0, animated: previous !== null })}>
                <video src='./video/home.mp4' muted loop="loop" autoPlay id='homevideo' />
                <div className="txt" />
            </div>
            {/* 第 2 屏：文物易绘 */}
            <div className={cls('carousel-slide', { active: current === 1, previous: previous === 1, animated: previous !== null })}>
                <ArchaeologySlide active={current === 1} />
            </div>
            {/* 轮播控制：屏切换指示条（带切换进度） */}
            <div className='carousel-footer'>
                <button
                    type='button'
                    className={cls('slide-selector', { selected: current === 0 })}
                    aria-label='切换至智慧文旅'
                    aria-current={current === 0}
                    onClick={() => goToSlide(0)}
                >
                    <span className='selector-track'><i ref={el => { trackRefs.current[0] = el }} /></span>
                </button>
                <button
                    type='button'
                    className={cls('slide-selector', { selected: current === 1 })}
                    aria-label='切换至文物易绘'
                    aria-current={current === 1}
                    onClick={() => goToSlide(1)}
                >
                    <span className='selector-track'><i ref={el => { trackRefs.current[1] = el }} /></span>
                </button>
            </div>
        </div>
        <IntroFooter />
    </div>
    )
}